module.exports = __webpack_public_path__ + "img/Medals_32@2x.49972367.png";